(function () {
    'use strict';

    angular
        .module('glossaryTermModule')
        .controller('glossaryTermFullController', Controller);

    Controller.$inject = ['$scope', '$state', '$mdToast', 'glossaryTermService'];

    function Controller($scope, $state, $mdToast, glossaryTermService) {

       

        // Select Owner
        $scope.selectOwner = function (person) {
            $scope.boxModel.Owner = person;
            $scope.boxModel.OwnerID = person.ItemPersonID;
            $scope.pageIsDirty();
        }

        // Add Owner Delegate
        $scope.addOwnerDelegate = function (ownerDelegate) {
            if (_.isUndefined($scope.boxModel.OwnerDelegates)) $scope.boxModel.OwnerDelegates = [];

            $scope.boxModel.OwnerDelegates.push(ownerDelegate);
            $scope.pageIsDirty();
        }

        // Remove Owner Delegate
        $scope.removeOwnerDelegate = function (ownerDelegate) {
            $scope.boxModel.OwnerDelegates = _.reject($scope.boxModel.OwnerDelegates, { ItemPersonID: ownerDelegate.ItemPersonID });
            $scope.pageIsDirty();
        }

        // Show Reset Action?
        $scope.showResetAction = function () {
            if (!$scope.canEdit) return false;

            return $scope.ctxtCtrl.needSaveChanges;
        };

        // Reset forms
        $scope.reset = function () {
            $scope.isLoading = true;
            $state.reload();
        }
        
        // Show Save Action
        $scope.showSaveAction = function (form) {
            if (!$scope.canEdit) return false;
            if (!$scope.boxModel.ControlID) return false;
            if (form.$invalid) return false;

            return $scope.ctxtCtrl.needSaveChanges;
        }

        // Show Add Action
        $scope.showAddAction = function (form) {
            if ($scope.boxModel.ControlID) return false;
            if (form.$invalid) return false;

            return $scope.canEdit;
        }

        // Create Or Update
        $scope.createOrUpdate = function () {
            $scope.isLoading = true;
            $scope.boxModel.ItemOrderID = $scope.boxModel.DisplayItemOrderID;

            glossaryTermService
                .createOrUpdateGlossaryTerm($scope.boxModel)
                .then(function (updatedGlossaryTerm) {

                    if (_.isUndefined($scope.boxModel.LookupAttributeValueID)) {
                       
                        $mdToast.show(
                         $mdToast
                             .simple()
                             .content('Glossary Term has been added!')
                             .position('top right')
                             .hideDelay($scope.govNotificationDelay)
                             .action('OK')
                             .theme('primary'));

                        $state.go('glossaryTerm', { GlossaryTermID: updatedGlossaryTerm.LookupAttributeValueID, SkipDirtyCheck: true });
                    }
                    else {
                        
                        $mdToast.show(
                            $mdToast
                                .simple()
                                .content('Your changes have been saved!')
                                .position('top right')
                                .hideDelay($scope.govNotificationDelay)
                                .action('OK')
                                .theme('primary')
                        );

                        $scope.pageIsNotDirty();
                    }
                })
                .finally(function () {
                    $scope.isLoading = false;
                });
        };

    }

})();